module.exports = __webpack_public_path__ + "img/49.70f65eea.jpg";